module.exports = __webpack_public_path__ + "static/WEDDING E&M-179-2a87e6685b34fb1399bd9f8c1fc3a863.jpg";